export default __webpack_public_path__ + "static/media/buy-keyboard.0ef791c9.jpg";